import React from "react";
import contentfulSeriesApp from "@insightfulscience/contentful/Apps/Series";
import PageMeta from "@insightfulscience/smart-react/PageMeta";
import { useLocale } from "@insightfulscience/smart-react/i18";
import pipe from "@insightfulscience/shared-utils/fn/pipe";
import SectionTryForFree from "../../SectionTryForFree";
import SiteLayout from "../../SiteLayout";
import WithServices from "../../services";
import withErrorHandling from "../../AppError/withErrorHandling";
import AcademyToC from "../../AcademyToC/AcademyToC";

const seriesLayout = ({ children }) => {
	const [t] = useLocale("series-page");
	return (
		<SiteLayout>
			<PageMeta>
				<PageMeta.Twitter image={t("META_TWITTER_IMAGE")} isImageBaseUrl />
			</PageMeta>
			{children}
			<SectionTryForFree />
		</SiteLayout>
	);
};

const ContenfulSeriesApp = contentfulSeriesApp({
	Layout: seriesLayout,
	contentfulProps: {
		environment: process.env.CTF_ENV,
		space: process.env.CTF_SPACE,
		accessToken: process.env.CTF_TOKEN,
	},
	pageProps: {
		brandCode: "gp",
		siteDomain: "https://www.graphpad.com",
		academyToCComponent: {
			Component: AcademyToC,
		},
	},
});

export default pipe(ContenfulSeriesApp, withErrorHandling, WithServices);
